<template>


  <div class="card dewidget">
    <div class="card-header" v-show="title">
      <div class="card-header-wrapper">
        <div class="card-header-item" :class="{'text-middle':newUrl}">
          {{this.title}}
        </div>
        <div class="card-header-item text-right" v-if="newUrl || backUrl">
          <!--<router-link class="el-button el-button&#45;&#45;warning el-button&#45;&#45;mini el-router-link" :to="{path:backUrl}" v-if="backUrl"><i class="fa fa-plus-circle"></i> Geri</router-link>-->
          <!--<router-link class="el-button el-button&#45;&#45;primary el-button&#45;&#45;mini el-router-link" :to="{path:newUrl}" v-if="newUrl"><i class="fa fa-plus-circle"></i> Yeni</router-link>-->
          <!--<el-button size="mini" type="primary"><i class="fa fa-plus"></i> Yeni {{newUrl}}</el-button>-->
          <el-button size="mini" type="warning" v-if="backUrl" @click="handleBackButton"><i class="fa fa-backward"></i> Geri</el-button>
          <el-button size="mini" type="primary" v-if="newUrl" @click="handleNewButton"><i class="fa fa-plus-circle"></i> Yeni</el-button>
        </div>
      </div>
    </div>
    <div class="card-body">
      <slot></slot>
    </div>
  </div>

</template>

<script>
  export default {
    name: 'Widget',
    props: ['title', "new-url","back-url"],
    data() {
      return {}
    },
    created() {

    },
    methods:{
      handleNewButton(){
        this.$router.push({path:this.newUrl })
      },
      handleBackButton(){
        this.$router.push({path:this.backUrl})
      }
    }
  }
</script>

<style>
  .card-header-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .card-header-item {
    flex-grow: 1;
  }

  .el-router-link,
  .el-router-link:hover,
  .el-router-link:active,
  .el-router-link:focus
  {
    text-decoration: none !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/Base/Widget.vue